import { AuthorizedRoute } from 'Components/AppLayout';
import { SITE_PAGES } from 'Config';
import { useAuthContext } from 'Context';
import { withRouter } from 'Lib/hoc';
import Users from 'Pages/Admin/Users';
import { Route, Routes } from 'react-router';

const Admin = ({ context }) => {
  const { isLoggedIn } = useAuthContext();

  return (
    <Routes>
      <Route
        path=''
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.MANAGE_USERS.requiredAuth}>
            <Users />
          </AuthorizedRoute>
        }
      />
      <Route
        path='users/*'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.MANAGE_USERS.requiredAuth}>
            <Users />
          </AuthorizedRoute>
        }
      />
    </Routes>
  );
};

let Page = withRouter(Admin);
export default Page;
